import type { TopicDef } from "../../types";
import { anglesTriangle } from "./anglesTriangle";
import { average } from "./average";
import { compositeArea } from "./compositeArea";
import { equationsSimple } from "./equationsSimple";
import { expressionsEval } from "./expressionsEval";
import { fractionsDecimals } from "./fractionsDecimals";
import { integersOps } from "./integersOps";
import { orderOfOps } from "./orderOfOps";
import { percent } from "./percent";
import { ratios } from "./ratios";
import { speedDistanceTime } from "./speedDistanceTime";

export const SP6_TOPICS: readonly TopicDef[] = [
  integersOps,
  orderOfOps,
  fractionsDecimals,
  percent,
  ratios,
  equationsSimple,
  expressionsEval,
  speedDistanceTime,
  anglesTriangle,
  compositeArea,
  average,
];
